import Immutable from 'seamless-immutable';
import { Office } from '../stores';
import { OfficeActions } from '../actions';

const initialState = Immutable(Office);

export function office(state = initialState, action) {
	switch (action.type) {
		case OfficeActions.FetchOfficesAction.Success: {
			return state.merge({ offices: action.payload });
		}
		case OfficeActions.GetOfficeAction.Success: {
			return state.merge({ office: action.payload });
		}
		case OfficeActions.UnloadOfficeAction.Success: {
			return state.merge({ office: null });
		}
		default: {
			return state;
		}
	}
}
